import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_PROFB2_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfB2ReferenceData = createAsyncThunk(
    'stop/getProfB2ReferenceData',
    async (params) => {
      const config = {
        headers: {
          Authorization: params,
          Region: STOP_REGION
        },
      };
      const response = await axios
        .get(EPISODE_PROFB2_REFERENCE_DATA_URL, config)
        .then((response) => {
          return response;
        })
        .catch((e) => {
          console.log(e);
          return e;
        });
      const data = await response.data.data;
      return data === undefined ? null : data;
    }
  );

  const profB2ReferenceDataSlice = createSlice({
    name: 'stop/profB2Reference',
    initialState: null,
    reducers: {
      resetProfB2Reference: () => null,
    },
    extraReducers: {
      [getProfB2ReferenceData.fulfilled]: (state, action) => action.payload,
    },
  });
  
  export const { resetProfB2Reference } = profB2ReferenceDataSlice.actions;
  
  export default profB2ReferenceDataSlice.reducer;